(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fortisana-faq"] && !Shopify.designMode) return;
  try {
    
  /* hero tags: fold after three lines (phones mostly) behind "Alle
     Kategorien"; the toggle only appears when there is a fourth line */
  (() => {
    document.querySelectorAll('[data-fxq-tags]').forEach((nav) => {
      const more = nav.parentElement.querySelector('[data-fxq-tags-more]');
      if (!more) return;
      const tags = [...nav.querySelectorAll('.fxq-hero__tag')];
      const measure = () => {
        nav.classList.remove('is-collapsed');
        nav.style.maxHeight = '';
        const tops = [...new Set(tags.map((t) => Math.round(t.offsetTop)))].sort((a, b) => a - b);
        if (tops.length <= 3 || nav.classList.contains('is-open')) { more.hidden = tops.length <= 3; if (tops.length <= 3) nav.classList.remove('is-open'); return; }
        const fourth = tags.find((t) => Math.round(t.offsetTop) === tops[3]);
        const gap = parseFloat(getComputedStyle(nav).rowGap) || 10;
        nav.style.setProperty('--fxq-tags-h', (fourth.offsetTop - gap) + 'px');
        nav.classList.add('is-collapsed');
        more.hidden = false;
      };
      more.addEventListener('click', () => {
        const open = !nav.classList.contains('is-open');
        nav.classList.toggle('is-open', open);
        nav.classList.toggle('is-collapsed', !open);
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? 'Weniger anzeigen' : 'Alle Kategorien';
      });
      measure();
      window.addEventListener('resize', () => { if (!nav.classList.contains('is-open')) measure(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
